import React, {useState} from 'react';
import {Navigate} from "react-router-dom";

const Authorization = ({redirectTo, children}) => {

    const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem('auth') === 'Y')
    if (isAuthenticated) {
        return <>{children}</>;
    } else {
        return <Navigate to={redirectTo} />;
    }
};

export default Authorization;